import { init } from "@sentry/nextjs";
import { filterBrowserError } from "@/lib/browser-error-filter";
import { GLITCHTIP_DSN, sharedSentryOptions } from "@/lib/glitchtip";

init({
  ...sharedSentryOptions,
  // `||` on purpose: Dokploy passes the build arg as an empty string.
  dsn: process.env.NEXT_PUBLIC_SENTRY_DSN || GLITCHTIP_DSN,
  beforeSend: (event) => filterBrowserError(event),
});
